import React, { useState, useEffect } from "react";

import Form from "@Components/Form";
import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";

import SaveIcon from "@material-ui/icons/Save";

const detailURL = "/configuration/get-config/";

const AudioSetting = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [sosAudioDuration, setSosAudioDuration] = useState(0);
  const [grievanceAudioDuration, setGrievanceAudioDuration] = useState(0);
  const [sosAudioLife, setSosAudioLife] = useState(0);
  const [grievanceAudioLife, setGrievanceAudioLife] = useState(0);
  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.grievance_audio_duration) {
            setGrievanceAudioDuration(response.data.grievance_audio_duration);
          }
          if (response.data.sos_audio_duration) {
            setSosAudioDuration(response.data.sos_audio_duration);
          }
          if (response.data.grievance_audio_life_span) {
            setGrievanceAudioLife(response.data.grievance_audio_life_span);
          }
          if (response.data.sos_audio_life_span) {
            setSosAudioLife(response.data.sos_audio_life_span);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };
  const initialValues = {
    grievance_audio_duration: grievanceAudioDuration,
    sos_audio_duration: sosAudioDuration,
    grievance_audio_life_span: grievanceAudioLife,
    sos_audio_life_span: sosAudioLife,
  };

  useEffect(() => {
    fetchDetails();
  }, [  ]);

  const formFields = [
    {
      name: "grievance_audio_duration",
      type: "input",
      label: "Grievance Audio Duration (In seconds)",
      color: "primary",
      required: true,
      size: "medium",
      value: grievanceAudioDuration,
    },
    {
      name: "sos_audio_duration",
      type: "input",
      label: "SOS Audio Duration (In seconds)",
      color: "primary",
      required: true,
      size: "medium",
      value: sosAudioDuration,
    },
    {
      name: "grievance_audio_life_span",
      type: "input",
      label: "Grievance Audio Life Span (In months)",
      color: "primary",
      required: true,
      size: "medium",
      value: grievanceAudioLife,
    },
    {
      name: "sos_audio_life_span",
      type: "input",
      label: "SOS Audio Life Span (In months)",
      color: "primary",
      required: true,
      size: "medium",
      value: sosAudioLife,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
      startIcon: <SaveIcon />,
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, values)
      .then(() => {
        // setSosAudioDuration(values["sos_audio_duration"]);
        // setSosAudioLife(values["sos_audio_life_span"]);
        // setGrievanceAudioDuration(values["grievance_audio_duration"]);
        // setGrievanceAudioLife(values["grievance_audio_life_span"]);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        fetchDetails();

        setLoading(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        fetchDetails();

        setLoading(false);
      });
  };

  return (
    <Form
      initialValues={initialValues}
      outerSubmitHandler={handleSubmit}
      formFields={formFields}
      formButtons={formButtons}
      formTitle={t("Audio Setting")}
    />
  );
};

export default AudioSetting;
